export default function TikTokIcon({ size = 18 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-3.78h-3.14v12.47a2.89 2.89 0 1 1-2-2.75V9.45a6.08 6.08 0 1 0 5.14 6V9.08a7.96 7.96 0 0 0 4.77 1.57V7.5a4.85 4.85 0 0 1-1-.81Z" /></svg>;
}
